import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function Error404Page() {    
    const navigate = useNavigate();

    const goHome = () => {
        navigate('/');
    };
  
    return (
      <Container className="text-center" style={{ marginTop: '100px' }}>
        <Row>
          <Col className=''>
              <h1>404</h1>
              <p>¡Oops! La página que buscas no existe.</p>
              <Button variant="primary" onClick={goHome}>
                Regresar a Inicio
              </Button>
          </Col>
        </Row>
      </Container>
    );
}